import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import styles from './TokenizationConfirmationFormResult.module.scss';
import { ReactComponent as SuccessIcon } from './successIcon.svg';
import { ReactComponent as ErrorIcon } from './errorIcon.svg';

import Button from 'components/common/Button';

export type TokenizationConfirmationResultProps = {
    isOpen?: boolean;
    status: 'success' | 'error' | 'idle';
    errorMessage: string;
    onClose?: () => void;
    onAction?: () => void;
    attemps?: number;
};

export const TokenizationConfirmationResult: React.FC<TokenizationConfirmationResultProps> = (
    props,
) => {
    const [container] = useState(() => document.createElement('div'));
    const root = document.body;
    const dict = {
        success: {
            title: '¡Tu validación se realizó con éxito!',
            firstText: 'En breve verás la reversa reflejada en tu cuenta bancaria',
            buttonText: 'Volver a checkout',
            icon: <SuccessIcon />,
        },
        error: {
            ['invalid amount']: {
                title: 'Tu transacción no pudo ser validada, el monto ingresado no es correcto.',
                firstText: '',
                buttonText: 'Intenta nuevamente',
                icon: <ErrorIcon />,
            },
            ['max attemps']: {
                title: 'Tu transacción no pudo ser validada, has superado el número de intentos permitidos.',
                firstText: 'En unos minutos se reversará la transacción.',
                buttonText: 'Intenta nuevamente',
                icon: <ErrorIcon />,
            },
            ['invalid elapsed time']: {
                title: 'Tu transacción no pudo ser validada, el tiempo de espera ha sido superado.',
                firstText: 'En unos minutos se reversará la transacción.',
                buttonText: 'Intenta nuevamente',
                icon: <ErrorIcon />,
            },
            ['risk']: {
                title: 'Lo sentimos.',
                firstText:
                    'el medio de pago esta presentando inconveniente por favor utilizar el medio de pago Webpay.',
                buttonText: 'Entendido',
                icon: <ErrorIcon />,
            },
            ['default']: {
                title: 'Tu transacción no pudo ser validada.',
                firstText: 'No hemos realizado la transacción, intenta nuevamente',
                buttonText: 'Intenta nuevamente',
                icon: <ErrorIcon />,
            },
        },
    };

    let selected =
        props.status === 'success'
            ? dict.success
            : dict.error[props.errorMessage as keyof typeof dict.error];

    if (props.attemps === 0 && props.errorMessage === 'invalid amount') {
        selected = dict.error['max attemps'];
    }

    useEffect(() => {
        root.appendChild(container);
        return () => {
            root.removeChild(container);
        };
    }, [container, root]);

    const component = (
        <div className={styles.wrapper}>
            <div className={`${styles.modal}`} data-testid="modal">
                <div className={styles.header}>
                    <div className={styles.title}>Cargo tarjeta</div>
                    <button onClick={props.onClose} data-testid="close-button" />
                </div>
                <div className={styles.body}>
                    <div className={styles.container}>
                        <div className={styles.content}>
                            <div className={styles.image}>{selected.icon}</div>
                            <div className={styles.firstText}>{selected.title}</div>
                            <div className={styles.secondText}>{selected.firstText}</div>
                            <div data-testid="tokenization-confirmation-result-attemps">
                                <Button theme={'primary'} size={'large'} onClick={props.onAction}>
                                    {selected.buttonText}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    return props.isOpen ? ReactDOM.createPortal(component, container) : null;
};
